import { StatusHistoryChainModel, TransportMode } from '../../../../common';

export class ShipmentWaybillStatusHistoryMainInfo {
  reference: string;
  carriers: string[];
  carriageConditionCodes: string[];
  transportServicePriorityCode: string;
  transportMode: TransportMode;
}

export class ShipmentWaybillStatusHistoryStatuses {
  statuses: StatusHistoryChainModel[];
}

export class ShipmentWaybillStatusHistory {
  mainIfo: ShipmentWaybillStatusHistoryMainInfo;
  statusHistoryView: ShipmentWaybillStatusHistoryStatuses;
}
